export const layoutSizes = {
  containerWidth: 1600,
  contentSpacing: 2,
  headerHeight: 64,
  navbarWidths: [47, 256],
  bottomNavigationHeight: 60,
  borderWidth: 1,
} as const;
